function envBool(v: string | undefined, def: boolean): boolean {
  if (v === undefined) return def;
  return v === 'true' || v === '1';
}

const isDev = import.meta.env.DEV;

/**
 * SPA runtime config. In dev, `devAuth` defaults on so the app talks to a
 * DEV_AUTH_BYPASS API without a real OAuth round-trip (the prod OAuth client
 * isn't registered until release). In prod builds it defaults off.
 */
export const webConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  issuer: import.meta.env.VITE_OAUTH_ISSUER ?? 'https://auth.thelangstonco.com/oauth',
  clientId: import.meta.env.VITE_OAUTH_CLIENT_ID ?? 'almanac-web',
  audience: import.meta.env.VITE_OAUTH_AUDIENCE ?? 'https://almanac.thelangstonco.com',
  redirectUri:
    import.meta.env.VITE_OAUTH_REDIRECT_URI ??
    (typeof window !== 'undefined' ? `${window.location.origin}/auth/callback` : ''),
  // The shared Langston AS (langston-api oidc-provider) models resource-server
  // access via the `mcp` scope: it supports only `mcp`/`offline_access` (+ auto
  // `openid`), does not define `email`/`profile`, and its grant logic only ever
  // grants `mcp`/`offline_access`. Almanac is a resource server, so it requests
  // `mcp offline_access` to obtain a resource-indicated JWT (aud = this app) plus
  // a refresh token. Our RS validates `iss`+`aud`+`sub` only (no scope/claims),
  // so `openid email profile` is neither supported by the AS nor needed here —
  // requesting it leaves the grant unsatisfied and loops the consent screen.
  scope: import.meta.env.VITE_OAUTH_SCOPE ?? 'mcp offline_access',
  devAuth: envBool(import.meta.env.VITE_DEV_AUTH, isDev),
} as const;
